/**
 * Make the cart's "Billing Address is same as Shipping Address" checkbox real.
 *
 * Core (webshop/templates/includes/cart/cart_address.html) renders the checkbox
 * but its only handler is toggle_billing_address_section() - a .toggle() on the
 * billing card. Nothing is sent to the server, so a customer whose only Address
 * is type "Billing" ticks the box, sees the UI agree, and is still rejected at
 * Place Order with "Set Shipping Address" - with no way out, since core's
 * Shipping panel only ever lists address_type == "Shipping".
 *
 * Bind `click` rather than `change`: core's own setup_state() fires
 * .trigger('change') on every page load, which would otherwise post a spurious
 * update before the customer has touched anything.
 */
frappe.ready(function () {
	if (!window.location.pathname || !window.location.pathname.startsWith("/cart")) {
		return;
	}

	var SELECTOR = "#input_same_billing";

	function showCartError(message) {
		var msg = message || frappe._("Something went wrong!");
		if (window.jQuery && typeof window.jQuery === "function") {
			window.jQuery("#cart-error").empty().html(msg).toggle(true);
			return;
		}
		var node = document.getElementById("cart-error");
		if (node) {
			node.innerHTML = msg;
			node.style.display = "block";
		}
	}

	function serverMessage(r) {
		if (!r || !r._server_messages) {
			return "";
		}
		try {
			return JSON.parse(r._server_messages || "[]")
				.map(function (m) {
					try {
						return JSON.parse(m).message;
					} catch (e) {
						return m;
					}
				})
				.join("<br>");
		} catch (e) {
			return "";
		}
	}

	function onToggle(e) {
		var checkbox = e.currentTarget;
		var enabled = checkbox.checked ? 1 : 0;

		// Guard against a double-post while the request is in flight; core's
		// own handler has already run and toggled the billing card's visibility.
		if (checkbox.dataset.webhqBusy === "1") {
			return;
		}
		checkbox.dataset.webhqBusy = "1";
		checkbox.disabled = true;

		frappe.call({
			type: "POST",
			method: "raftor_webhq.checkout.simple_checkout.set_shipping_same_as_billing",
			args: { enabled: enabled },
			callback: function (r) {
				checkbox.dataset.webhqBusy = "0";
				checkbox.disabled = false;

				if (r.exc) {
					// Put the checkbox back where it was - the cart did not change.
					checkbox.checked = !enabled;
					showCartError(serverMessage(r));
					return;
				}
				// Re-render the address cards from the corrected server state,
				// the same way core's own "add a new address" flow does.
				window.location.reload();
			},
			error: function (r) {
				checkbox.dataset.webhqBusy = "0";
				checkbox.disabled = false;
				checkbox.checked = !enabled;
				showCartError(serverMessage(r));
			},
		});
	}

	if (window.jQuery && typeof window.jQuery === "function") {
		window.jQuery(document).on("click", SELECTOR, onToggle);
		return;
	}

	document.addEventListener("click", function (e) {
		if (e.target && e.target.id === "input_same_billing") {
			onToggle({ currentTarget: e.target });
		}
	});
});
